export function Unauthorized() {
    return (
        <>
            <h1>User is not authorized!</h1>
        </>
    )
}
